import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './DCChargingLoader.css';

/** Reconnect steps stay hidden until the session has been starting this long. */
const RECONNECT_INFO_DELAY_MS = 30_000;

export default function DCChargingLoader({ sessionStartedAtMs = null }) {
  const { t } = useTranslation();
  const [showReconnectInfo, setShowReconnectInfo] = useState(false);
  const steps = t('dcChargingLoader.steps')
    .split(' > ')
    .map(step => step.trim())
    .filter(Boolean);

  useEffect(() => {
    const startedAt = Number.isFinite(sessionStartedAtMs) ? sessionStartedAtMs : Date.now();
    const remaining = RECONNECT_INFO_DELAY_MS - (Date.now() - startedAt);
    if (remaining <= 0) {
      setShowReconnectInfo(true);
      return undefined;
    }
    setShowReconnectInfo(false);
    const timeoutId = window.setTimeout(() => setShowReconnectInfo(true), remaining);
    return () => window.clearTimeout(timeoutId);
  }, [sessionStartedAtMs]);

  return (
    <div className="dc-charging-loader">
      <div className="dc-charging-loader-arrows" aria-hidden="true">
        <span>&gt;</span>
        <span>&gt;</span>
        <span>&gt;</span>
      </div>
      <p className="dc-charging-loader-status">{t('dcChargingLoader.starting')}</p>
      {showReconnectInfo ? (
        <div className="dc-charging-loader-content" aria-live="polite">
          <div className="dc-charging-loader-text">
            <p className="dc-charging-loader-title">{t('dcChargingLoader.title')}</p>
            <p className="dc-charging-loader-lead">{t('dcChargingLoader.lead')}</p>
            {steps.map((step, index) => (
              <p key={step} className="dc-charging-loader-step">
                {index > 0 ? (
                  <span className="dc-charging-loader-arrow" aria-hidden="true">
                    &gt;
                  </span>
                ) : null}
                {step}
              </p>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
}
